export const isInMwEditDesignABTest = () =>
  evite.experiments.inVariation('test_mw-step-4-edit-card', 'variant', false);
